import React, { PropTypes } from 'react';
import { isPlainObject, isEmpty } from 'lodash';

export default function ErrorMessages({ header, fields }) {
  if (!isPlainObject(fields)) {
    return null;
  }

  const messages = Object
    .keys(fields)
    .filter(key => fields[key].touched)
    .filter(key => fields[key].error)
    .map(key => fields[key].error);

  if (isEmpty(messages)) {
    return null;
  }

  return (
    <div className="ui error message">
      <div className="header">{header}</div>
      <ul className="list">
        {
          messages.map((message, key) => <li key={key}>{message}</li>)
        }
      </ul>
    </div>
  );
}

ErrorMessages.defaultProps = {
  header: 'Opps',
  fields: {},
};

ErrorMessages.propTypes = {
  header: PropTypes.string,
  fields: PropTypes.object,
};
